import React, { useEffect, useState } from "react";
import PolicyList from "../PolicyList/PolicyList";
import "./Endorsement.css";
import axios from "axios";

const Endorsement = () => {
    const [policyList, setPolicyList] = useState([]);
    const [loading, setLoading] = useState(true);  // New loading state
    const getPolicyList = (data) => {
        setPolicyList(data);
    }
    const handleLoading = (isLoading) => {
        setLoading(isLoading);
    };
    return (

        <>
            {policyList?.length > 0 ? <h4>Select the policy which you want to endorse ({policyList?.length})</h4> :
            <div className="alert alert-danger" role="alert">
                    <i className="fas fa-exclamation-triangle"></i> No policies available for endorsement.
            </div>
            }
            <PolicyList
                onSendData={getPolicyList}
                RedirectToEndorse={"/endorse-form"}
                onLoading={handleLoading}/>
        </>
    );
};

export default Endorsement;
